import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CommandRelay } from "../CommandRelay";
export var RelayBuilder = /*#__PURE__*/function () {
  function RelayBuilder(name) {
    _classCallCheck(this, RelayBuilder);
    this.name = name;
    _defineProperty(this, "broker", void 0);
    _defineProperty(this, "queue", void 0);
    _defineProperty(this, "registry", void 0);
  }
  _createClass(RelayBuilder, [{
    key: "withBroker",
    value: function withBroker(broker) {
      this.broker = broker;
      return this;
    }
  }, {
    key: "withStorage",
    value: function withStorage(queue) {
      this.queue = queue;
      return this;
    }
  }, {
    key: "withRegistry",
    value: function withRegistry(registry) {
      this.registry = registry;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      if (!this.broker || !this.queue || !this.registry) throw new Error('Builder not initialized properly');
      return new CommandRelay(this.name, this.broker, this.queue, this.registry);
    }
  }]);
  return RelayBuilder;
}();